export default __webpack_public_path__ + "static/media/discord.0ee0c073.svg";